import React, { useEffect, useState } from "react";

export default function ConnectWithLawyers() {
  const [lawyers, setLawyers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const fetchLawyers = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/lawyers`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const data = await res.json();
        if (res.ok) {
          setLawyers(data.lawyers || []);
        } else {
          setError(data.message || "Failed to fetch lawyers.");
        }
      } catch {
        setError("Network error.");
      }
      setLoading(false);
    };
    fetchLawyers();
  }, []);

  const handleConnect = async (lawyerId) => {
    try {
      setSuccess("");
      setError("");
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/connect-lawyer/${lawyerId}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(data.message || "Connection request sent!");
      } else {
        setError(data.message || "Failed to connect.");
      }
    } catch {
      setError("Network error.");
    }
  };

  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold mb-4">Connect with Lawyers</h2>
      {error && <div className="text-red-600 mb-2">{error}</div>}
      {success && <div className="text-green-600 mb-2">{success}</div>}
      {loading ? (
        <div>Loading lawyers...</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded shadow">
            <thead>
              <tr>
                <th className="px-4 py-2 border">Name</th>
                <th className="px-4 py-2 border">Email</th>
                <th className="px-4 py-2 border">Specialization</th>
                <th className="px-4 py-2 border">Action</th>
              </tr>
            </thead>
            <tbody>
              {lawyers.length > 0 ? (
                lawyers.map((lawyer) => (
                  <tr key={lawyer.id}>
                    <td className="px-4 py-2 border">{lawyer.name}</td>
                    <td className="px-4 py-2 border">{lawyer.email}</td>
                    <td className="px-4 py-2 border">{lawyer.specialization || "N/A"}</td>
                    <td className="px-4 py-2 border">
                      <button
                        className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-800"
                        onClick={() => handleConnect(lawyer.id)}
                      >
                        Connect
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center py-4">
                    No lawyers found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}